jQuery(document).ready(function ($) {


  if ($(".slider-banner").length) {
    //$('.slider-banner').find('.wp-block-cover').each(function() {
    //var bgPos = $(this).css('background-position').split(' ');
    // console.log(bgPos);

    //var $innerContainer = $(this).find('.wp-block-cover__inner-container');
    //$innerContainer.css('left', bgPos[0]);
    //$innerContainer.css('top', bgPos[1]);
    //$innerContainer.css('transform', 'translate('+ (-100 + parseInt(bgPos[0])) +'%, '+ (-100 + parseInt(bgPos[1])) +'%)');

    //$innerContainer.addClass('show');
    //});

    //$('.slider-banner .wp-block-group__inner-container').not('.slider-banner .slider-banner-content .wp-block-group__inner-container').slick({
    var slickPrimary = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: false,
      autoplay: true,
      autoplaySpeed: 4000,
      asNavFor: ".slide-content-outer",
      infinite: true,
    };
    var slickNavigator = {
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      autoplay: true,
      autoplaySpeed: 4000,
      asNavFor: ".slider-wrap",
      //appendDots: $('.slide-content-inner'),
      speed: 500,
      dots: true,
      arrows: false,
      focusOnSelect: true,
      centerMode: false,
      infinite: true,
    };

    $(".slider-wrap").slick(slickPrimary);
    $(".slide-content-outer").slick(slickNavigator);
  }



  $('.wf-testimonial-slider-slides').slick({
      centerMode: false,
      //centerPadding: '27%',
      focusOnSelect: true,
      slidesToShow: 1,
      arrows: false,
     // autoplay: true,
      touchMove: false,
    swipe: false,
   // initialSlide: 2,
    });

    $('.wf-testimonial-slider-slides-2').slick({
      centerMode: false,
      //centerPadding: '27%',
      focusOnSelect: true,
      slidesToShow: 1,
      arrows: false,
     // autoplay: true,
      touchMove: false,
    swipe: false,
    //initialSlide: 1,
    });


    $('.wf-testimonial-slider-slides-3').slick({
      centerMode: false,
      //centerPadding: '27%',
      focusOnSelect: false,
      touchMove: false,
    swipe: false,
      slidesToShow: 1,
      arrows: false,
     // autoplay: true,
     // asNavFor: '.wf-testimonial-slider-slides-2,.wf-testimonial-slider-slides',
      dots: false
    });

    $('.wf-testimonial-slider-slides-4').slick({
      centerMode: false,
      //centerPadding: '27%',
      focusOnSelect: false,
      touchMove: false,
    swipe: false,
      slidesToShow: 1,
      arrows: false,
     // autoplay: true,
     // asNavFor: '.wf-testimonial-slider-slides-2,.wf-testimonial-slider-slides',
      dots: false
    });


  //Testimonial text Slider Block
  $('.testimonial-text-slides').slick({
    centerMode: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    pauseOnHover:false,
    pauseOnFocus: false, 
    arrows: false,
   // prevArrow: "<button type='button' class='slick-prev' aria-label='Previous'><div data-name='Previous Arrow' class='wf-slider-prev-icon' aria-hidden='true'><svg xmlns='http://www.w3.org/2000/svg' width='57' height='57' viewBox='0 0 57 57'><g id='Left_Arrow' data-name='Left Arrow' transform='translate(-1170 -2403)'><g id='Ellipse_31' data-name='Ellipse 31' transform='translate(1170 2403)' fill='none' stroke='#854d96' stroke-width='3'><circle cx='28.5' cy='28.5' r='28.5' stroke='none'/><circle cx='28.5' cy='28.5' r='27' fill='none'/></g><path id='Path_366' data-name='Path 366' d='M9.548,0l2.217,1.351,1.882,2.169v.242l-.916.916-.241.1L5.98,12.055v.289l5.351,5.547.531,2.169L9.981,22.519,7.86,21.7,4.726,18.95l-1.254-1.4L.483,14.562l-.29-1.3v-.387L0,12.538v-.821L1.255,9.692Z' transform='translate(1190.107 2420.241)' fill='#854d96'/></g></svg></div></button>",
    //nextArrow: "<button type='button' class='slick-next' aria-label='Next'><div data-name='Next Arrow' class='wf-slider-next-icon' aria-hidden='true'><svg id='Right_Arrow' data-name='Left Arrow' xmlns='http://www.w3.org/2000/svg' width='57' height='57' viewBox='0 0 57 57'><g id='Right_Ellipse_31' data-name='Ellipse 31' fill='none' stroke='#854d96' stroke-width='3'><circle cx='28.5' cy='28.5' r='28.5' stroke='none'/><circle cx='28.5' cy='28.5' r='27' fill='none'/></g><path id='Right_Path_366' data-name='Path 366' d='M4.1,0,1.882,1.351,0,3.519v.242l.916.916.241.1,6.51,7.281v.289L2.315,17.891,1.784,20.06l1.882,2.459L5.786,21.7,8.921,18.95l1.254-1.4,2.989-2.99.29-1.3v-.387l.192-.337v-.821L12.392,9.692Z' transform='translate(23.246 17.241)' fill='#854d96'/></svg></div></button>",
    asNavFor: '.wf-testimonial-slider-slides-4,.wf-testimonial-slider-slides-3,.wf-testimonial-slider-slides-2,.wf-testimonial-slider-slides',
    dots: true,
    swipe: true,
    //infinite: false,
    swipeToSlide: true,
    //adaptiveHeight: true,
    responsive: [{
      breakpoint: 1024,
      settings: {
        arrows: false,
        appendDots: $('.wf-testimonial-slider-image-block-inner')
      },
    }, ],
  });


  $('.wf-product-slider').slick({
    autoplay: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: false,
    draggable: false,
    arrows: false,
    dots: false,
    touchMove: false,
    swipe: false,
    //asNavFor: '.slider-nav-thumbnails',
  });

  $('.slider-nav-thumbnails').slick({
    autoplay: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    draggable: false,
    focusOnSelect: false,
    asNavFor: '.wf-product-slider',
    dots: false,
    centerMode: false,
    //focusOnSelect: false,
    touchMove: false,
    swipe: false,

  });

  /*  $('.slider-nav-thumbnails .slick-slide').on('click', function (event) {
     $('.wf-product-slider').slick('slickGoTo', $(this).data('slickIndex'));
     $('.slider-nav-thumbnails .slick-slide').removeClass( 'slick-current' );
     $(this).toggleClass('slick-thumb-current');
  }); */

  // Remove active class from all thumbnail slides
  $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');

  // Set active class to first thumbnail slides
  $('.slider-nav-thumbnails .slick-slide').eq(0).addClass('slick-active');

  // On before slide change match active thumbnail to current slide
  /* $('.wf-product-slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    var mySlideNumber = nextSlide;
    $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
    $('.slider-nav-thumbnails .slick-slide').eq(mySlideNumber).addClass('slick-active');
  }); */

  $('.slider-nav-thumbnails .slick-slide').on('click', function (event) {
    $('.wf-product-slider').slick('slickGoTo', $(this).data('slickIndex'));
    $('.slider-nav-thumbnails .slick-slide').removeClass('slick-active');
    $(this).addClass('slick-active');
  });

});